import React from 'react'
import styles from './ActionDisplay.module.css'

export interface Action {
    action: string
    parameters?: Record<string, any>
    message?: string
}

export interface ActionResponse {
    data?: {
        action?: string
        actions?: Action[]
        parameters?: Record<string, any>
        message?: string
    }
    error?: string
    details?: string  // Add support for detailed error information like stack traces
}

interface ActionDisplayProps {
    actionData: ActionResponse | null
}

const ActionDisplay = ({ actionData }: ActionDisplayProps) => {
    if (!actionData) return null

    // Handle error responses
    if (actionData.error) {
        return (
            <div className="box mt-5 has-background-danger-light">
                <h4 className="title is-6 has-text-danger">Error</h4>
                <p className="mb-3 subtitle is-7">{actionData.error}</p>
                
                {/* If there are error details, show them in a collapsible section */}
                {actionData.details && (
                    <details className="mb-3">
                        <summary className="has-text-grey">Technical Details</summary>
                        <pre className="has-background-dark has-text-light p-3 is-size-7" style={{ maxHeight: '200px', overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                            {actionData.details}
                        </pre>
                    </details>
                )}
                
                {/* If there's also data with the error, display it */}
                {actionData.data && (
                    <div className="content">
                        <h6 className="title is-6">Additional Information:</h6>
                        {actionData.data.message && (
                            <p>{actionData.data.message}</p>
                        )}
                        {actionData.data.parameters && Object.keys(actionData.data.parameters).length > 0 && (
                            <ul>
                                {Object.entries(actionData.data.parameters).map(([key, value]) => (
                                    <li key={key}>
                                        <strong>{key}:</strong> {typeof value === 'object' ? JSON.stringify(value) : value}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                )}
            </div>
        )
    }

    // Handle successful responses
    const actions: Action[] = actionData.data?.actions || 
        (actionData.data?.action ? [{
            action: actionData.data.action,
            parameters: actionData.data.parameters,
            message: actionData.data.message
        }] : [])

    if (actions.length === 0) {
        return (
            <div className="box mt-5 has-background-warning-light">
                <h4 className="title is-6 has-text-warning">No Actions</h4>
                <p className="mb-3 subtitle is-7">No actions were returned from the AI agent.</p>
            </div>
        )
    }

    return (
        <div className="mt-5">
            <h4 className="title is-6">Actions ({actions.length})</h4>
            <div className="is-multiline">
                {actions.map((action, index) => (
                    <div key={index} className="">
                        <div className={`box ${styles.actionCard}`}>
                            {/* <h5 className="title is-5 has-text-info">{action.action}</h5> */}
                            {action.message && (
                                <p className="mb-3">{action.message}</p>
                            )}
                            {/* {action.parameters && Object.keys(action.parameters).length > 0 && (
                                <div className="content">
                                    <h6 className="title is-6">Parameters:</h6>
                                    <ul>
                                        {Object.entries(action.parameters).map(([key, value]) => (
                                            <li key={key}>
                                                <strong>{key}:</strong> {typeof value === 'object' ? JSON.stringify(value) : value}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )} */}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default React.memo(ActionDisplay)
